import { nonUndefined } from "Utility";
import { FsRankingGroup } from "db/model/tournament/FsRankingGroup";
import { RankingGroup } from "model/Tournament/RankingGroup";

export const mapRankingGroups = (fsModels: FsRankingGroup[]) => {
  return nonUndefined(fsModels.map(mapRankingGroup));
};

const mapRankingGroup = (fsModel: FsRankingGroup): RankingGroup | undefined => {
  if (!fsModel.startPosition) {
    return undefined;
  }

  return {
    startPosition: fsModel.startPosition,
    endPosition: fsModel.endPosition,
    accentColor: fsModel.accentColor,
  };
};
